import { render, staticRenderFns } from "./ChangeLogModal.vue?vue&type=template&id=1d9e51de&scoped=true"
import script from "./ChangeLogModal.vue?vue&type=script&lang=js"
export * from "./ChangeLogModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogModal.vue?vue&type=style&index=0&id=1d9e51de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9e51de",
  null
  
)

export default component.exports